import React from 'react'
import MessageUI from '../output/MessageUI'
import './ViewOrUpdate2.css'

const ViewOrUpdate2UI = ({messageList, labelKey, editable, editMode, onEditClick, value, children}) =>
  <div className='w_lbl_val'>
    <div className='g_small g_muted'>
      <MessageUI messageList={messageList} messageKey={labelKey} />
    </div>
    {
      !editMode &&
      <div className='read' onClick={editable ? onEditClick : null}>
        <label>{value}</label>
        {
          editable &&
          <div className='icon icon-angle-down g_link_2' />
        }
      </div>
    }
    {
      editMode &&
      <React.Fragment>
        {children}
      </React.Fragment>
    }
  </div>

export default ViewOrUpdate2UI
